import { Link } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { StickyCTA } from "@/components/site/StickyCTA";

export const PageLayout = ({ eyebrow, title, titleAccent, intro, bgImage, children }) => (
  <div className="pb-20 md:pb-0">
    <Navbar />
    <header data-testid="page-header" className="pt-32 md:pt-40 pb-12 md:pb-16 bg-[#0E0E11] border-b border-white/10 jpd-grain relative overflow-hidden">
      {bgImage && (
        <>
          <img src={bgImage} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover object-center" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0E0E11]/95 via-[#0E0E11]/80 to-[#0E0E11]/40" />
        </>
      )}
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10 relative">
        {eyebrow && (
          <div className="flex items-center gap-3">
            <span className="h-[2px] w-10 bg-[#EA0A0B]" />
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400">{eyebrow}</p>
          </div>
        )}
        <h1 className="mt-5 font-display uppercase leading-[0.95] tracking-wide text-4xl sm:text-5xl lg:text-6xl text-white">
          {title} {titleAccent && <span className="text-[#EA0A0B]">{titleAccent}</span>}
        </h1>
        {intro && <p className="mt-5 max-w-2xl text-base text-slate-300 leading-relaxed">{intro}</p>}
      </div>
    </header>
    <main>{children}</main>
    <Footer />
    <StickyCTA />
  </div>
);

export const PageBody = ({ children }) => (
  <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10 py-14 md:py-20">{children}</div>
);

export const BookNowButton = ({ to = "/book", label = "Book Now", testid = "page-book-now-button" }) => (
  <Link
    to={to}
    data-testid={testid}
    className="inline-flex items-center justify-center bg-[#EA0A0B] hover:bg-[#C20A0B] text-white font-display uppercase tracking-[0.12em] text-sm px-10 py-4 transition-colors"
  >
    {label}
  </Link>
);
